import { render, staticRenderFns } from "./template.vue?vue&type=template&id=4af00b0c&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=4af00b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af00b0c",
  null
  
)

export default component.exports